import { css } from '@emotion/core'

export default {
  changeHistoryP: css`
    margin: 0;
    font-size: small;
  `,
  loading: css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 25vh;
    overflow-y: none;
    svg {
      height: 40px;
      width: 40px;
    }
  `,
  navButton: css`
    align-self: center;
    margin-top: 10px;
    padding: 0;
  `,
  navWrapper: css`
    display: flex;
    gap: 8px;
    padding: 0;
    width: 100%;
    justify-content: space-between;
    select {
      width: 100%;
    }
  `,
  openChangeHistory: css`
    padding: 8px 0;
  `,
}
